import React from 'react';

export default function Loading() {
  return (
    <div>
      <span className="icon">
        <i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw" />
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Loading.js